import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Styles
import './styles/button.scss';

class Button extends PureComponent {
    static defaultProps = {
        busyIconCls: 'fluid-icon-spinner2',
        type: 'button',
        isPrimary: false,
        isSecondary: false,
        isLink: false,
        isDestructive: false,
        onClick: () => Promise.resolve(),
        onSetRef: () => Promise.resolve(),
    };

    static propTypes = {
        contextCls: PropTypes.string,
        busyIconCls: PropTypes.string,
        iconCls: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.oneOf(['button', 'submit']),
        disabled: PropTypes.bool,
        isDisabled: PropTypes.bool,
        busy: PropTypes.bool,
        isBusy: PropTypes.bool,
        isPrimary: PropTypes.bool,
        isSecondary: PropTypes.bool,
        isLink: PropTypes.bool,
        isDestructive: PropTypes.bool,
        data: PropTypes.object,
        onClick: PropTypes.func,
        onSetRef: PropTypes.func,
    };

    render() {
        const {
            contextCls,
            iconCls,
            text,
            busy,
            isBusy,
            children,
        } = this.props;
        const btnProps = this.getButtonProps();
        const modCls = this.getModCls();
        const isDisabled = this.getIsDisabled();

        return (
            // Disabling react/button-has-type due to
            // https://github.com/yannickcr/eslint-plugin-react/issues/1555
            // eslint-disable-next-line react/button-has-type
            <button
                {...btnProps}
                className={cx(this.baseCls, modCls, contextCls)}
                disabled={isDisabled}
                onClick={this.handleClick}
                ref={this.handleSetRef}
            >
                {!children && (
                    <span className={`${this.baseCls}__content`}>
                        {(busy || isBusy || iconCls) && this.renderIcon()}{' '}
                        {text && this.renderText()}
                    </span>
                )}
                {children}
            </button>
        );
    }

    renderIcon() {
        const { iconCls, busyIconCls, busy, isBusy, isLink } = this.props;

        return (
            <span
                className={cx(
                    `${this.baseCls}__icon`,
                    !isLink && (busy || isBusy)
                        ? `${busyIconCls} ${this.baseCls}__icon--busy`
                        : iconCls,
                )}
            />
        );
    }

    renderText() {
        const { text } = this.props;

        return <span className={`${this.baseCls}__text`}>{text}</span>;
    }

    handleSetRef = (el) => {
        const { onSetRef } = this.props;

        if (el) {
            this.btnRef = el;

            onSetRef(el);
        }
    };

    handleClick = (e) => {
        const { data, onClick } = this.props;

        onClick({ data, e });
    };

    getIsDisabled = () => {
        const { disabled, isDisabled, busy, isBusy, isLink } = this.props;

        return !isLink && (disabled || isDisabled || busy || isBusy);
    };

    getModCls = () => {
        const { isPrimary, isSecondary, isLink, isDestructive } = this.props;

        return {
            [`${this.baseCls}--primary`]:
                isPrimary && !isSecondary && !isDestructive && !isLink,
            [`${this.baseCls}--secondary`]:
                isSecondary && !isPrimary && !isLink,
            [`${this.baseCls}--link`]:
                isLink && !isSecondary && !isPrimary && !isSecondary,
            [`${this.baseCls}--destructive`]:
                !isPrimary && isDestructive && !isLink,
        };
    };

    getButtonProps = () => {
        const { text, ...rest } = this.props;
        const btnProps = { ...rest };
        delete btnProps.contextCls;
        delete btnProps.busyIconCls;
        delete btnProps.iconCls;
        delete btnProps.busy;
        delete btnProps.isBusy;
        delete btnProps.isDisabled;
        delete btnProps.isPrimary;
        delete btnProps.isSecondary;
        delete btnProps.isLink;
        delete btnProps.isDestructive;
        delete btnProps.data;
        delete btnProps.onClick;
        delete btnProps.onSetRef;

        return btnProps;
    };

    baseCls = 'fluid-button';
}

export default Button;
